import { cx } from 'emotion';
import { number, bool } from 'prop-types';
import React from 'react';

import { DeviceInfo } from '@ezugi/utils';

import {
  Container, TotalValue, DiceValue, singleDigitClassName, mobileContainerClassName,
} from './style';

export default function Stack({ DiceOne, DiceTwo, DiceThree, showDices }) {
  const total = DiceOne + DiceTwo + DiceThree;

  const isSmall = total <= 10;
  const isBig = total >= 11;
  const isTriple = DiceOne === DiceTwo && DiceOne === DiceThree;

  const dices = [ DiceOne, DiceTwo, DiceThree ].map((value, _, arr) => ({
    value,
    isDouble: arr.filter((val) => val === value).length === 2,
  }));

  return (
    <Container
      className={cx({
        triple: isTriple,
        small: isSmall,
        big: isBig,
        [mobileContainerClassName]: DeviceInfo.isHandheld,
      })}
    >
      <TotalValue className={total < 10 ? singleDigitClassName : null}>
        {total}
      </TotalValue>
      {showDices
        && dices.map(({ value, isDouble }, index) => (
          <DiceValue key={index} className={cx({ double: isDouble, triple: isTriple })}>
            {value}
          </DiceValue>
        ))}
    </Container>
  );
}

Stack.propTypes = {
  DiceOne: number,
  DiceTwo: number,
  DiceThree: number,
  showDices: bool,
};

Stack.defaultProps = {
  showDices: true,
};
